/*
 * Is this sales task late?
 *
 * Overdue = past its due timestamp AND not terminal. Terminal work — submitted,
 * auto-closed because the student converted or deleted their account, or
 * auto-completed because an instant task expired untouched — cannot be late,
 * which is why the status check comes first. It is the same
 * definition the server's "Overdue" status filter applies in SQL (statusClause
 * in sales_task_list/db.go: status NOT IN TerminalStatuses AND due_datetime <
 * UTC now). The two must agree, or a row could be returned by the Overdue tab
 * and then render without the highlight.
 *
 * Computed client-side rather than read from a server field: due_datetime_iso is
 * already on every row as an RFC3339 UTC instant, and moment parses that into the
 * correct absolute instant regardless of the viewer's timezone — so no extra
 * payload, and the highlight stays correct as the clock passes a due time between
 * renders.
 *
 * A row with no due timestamp is never overdue: with no deadline there is nothing
 * to be late for. Same for an unparseable one — a formatting bug should not paint
 * the table red.
 *
 * The highlight this drives is deliberately independent of the active status tab:
 * an overdue row seen under "All" or "Pending" is still overdue.
 */

import moment from 'moment-timezone';
import { is_terminal } from '../../util_components/instant_alert/task_status';

// Drives both the overdue highlight (terminal work is never late) and the row
// action label ("View", not "Open Task").
export { is_terminal };

const is_overdue = (item) => {
  if (!item || is_terminal(item)) return false;
  // An instant task carries its own urgency (the elapsed timer and its colour
  // thresholds), and its due_datetime is minutes away by construction. Painting
  // it overdue-red as well would make every instant row red within the hour and
  // drown out the timer that is the real signal.
  if (item.is_instant) return false;
  if (!item.due_datetime_iso) return false;
  const due = moment(item.due_datetime_iso);
  if (!due.isValid()) return false;
  return due.isBefore(moment());
};

export default is_overdue;
